/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coinvestments_Messages_Askquestion_Errortoast3Inputs */

const en_coinvestments_messages_askquestion_errortoast3 = /** @type {(inputs: Coinvestments_Messages_Askquestion_Errortoast3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Failed to send your question. Please try again.`)
};

/**
* | output |
* | --- |
* | "Failed to send your question. Please try again." |
*
* @param {Coinvestments_Messages_Askquestion_Errortoast3Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const coinvestments_messages_askquestion_errortoast3 = /** @type {((inputs?: Coinvestments_Messages_Askquestion_Errortoast3Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coinvestments_Messages_Askquestion_Errortoast3Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_coinvestments_messages_askquestion_errortoast3(inputs)
});
export { coinvestments_messages_askquestion_errortoast3 as "coInvestments_messages_askQuestion_errorToast" }